/**
 * TabNav component — adapted for react-router-dom
 * Uses Link and useLocation instead of next/link and usePathname
 */

import { Link, useLocation } from "react-router-dom";

export interface Tab {
  label: string;
  href: string;
  icon?: string;
}

interface TabNavProps {
  tabs: Tab[];
  className?: string;
}

export function TabNav({ tabs, className = "" }: TabNavProps) {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <nav
      className={`border-b border-border-default ${className}`}
      aria-label="Tabs"
    >
      <div className="flex gap-2 overflow-x-auto" role="tablist">
        {tabs.map((tab) => {
          const isActive =
            pathname === tab.href || pathname?.startsWith(tab.href + "/");
          return (
            <Link
              key={tab.href}
              to={tab.href}
              role="tab"
              aria-selected={isActive}
              aria-current={isActive ? "page" : undefined}
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap
                border-b-2 -mb-px transition-colors
                ${
                  isActive
                    ? "border-primary-500 text-primary-400"
                    : "border-transparent text-text-secondary hover:text-text-primary hover:border-border-default"
                }
              `}
            >
              {tab.icon && <span aria-hidden="true">{tab.icon}</span>}
              {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
